
<!--US Page-->
<div class="dtfdealerlocator" *ngIf="!isCanadaPortal">
   <!--Announcement Banner Code-->
   <div class="dtf-alertpage"></div>
 
 
     <!--Banner-->
     <section class="mbfs-home-hero"  style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Website_DealerLocators_Header.jpg);">
       <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">
             {{ 'DealerLocators.Header' | translate }}
         </h2>
          <p class="subheader">
             {{ 'DealerLocators.SubHeader' | translate }}
          </p>
         
       </section>
     </section>
     <div class="section-title-top">{{  'DealerLocators.ClickLinks' | translate }}</div>
      <ul>
       <div class="staticflex">
          <div>
             <div class="column-text">
                <li><div class="hyperlinktext"><a href="https://freightliner.com/dealer-search/" target="_blank">
                  <!-- <img src="/static/assets/img/dtf-assets/images/redesign/Freightliner_logo_footer.png"  style="width:109px; height:22px;">  -->
                  {{ 'DealerLocators.Freightliner' | translate }}</a></div></li>
                <li><div class="hyperlinktext"><a href="https://www.westernstartrucks.com/dealers/" target="_blank">
                  <!-- <img src="/static/assets/img/dtf-assets/images/redesign/western_star_logo_footer_cropped_W.png"  style="width:52px; height:23px;"> -->
                  {{ 'DealerLocators.WesternStar' | translate }}</a></div></li>
              
             </div>            
          </div>
 
          <div>
             <div class="column-text">
               <li><div class="hyperlinktext"><a href="https://thomasbuiltbuses.com/bus-sales-and-support/find-a-dealer/" target="_blank">
                  <!-- <img src="/static/assets/img/dtf-assets/images/redesign/thomas_logo_footer.png"  style="width:90px; height:30px;"> -->
                  {{ 'DealerLocators.ThomasBuilt' | translate }}</a></div></li>
               <li><div class="hyperlinktext"><a href="https://www.selectrucks.com/centers/" target="_blank">
                  <!-- <img src="/static/assets/img/dtf-assets/images/redesign/selectrucks_logo_footer.png"  style="width:114px; height:12px;"> -->
                  {{ 'DealerLocators.SelecTrucks' | translate }}</a></div></li>
             </div>
          </div>
       </div>
      </ul> 
     <div class="section-title-bottom">{{  'DealerLocators.ClickBrands' | translate }}</div>    
</div>
 
 <div class="dtfdealerlocator" *ngIf="isCanadaPortal">
   <div class="dtf-alertpage"></div>
     <!--Banner-->
    <section class="mbfs-home-hero"  style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Website_DealerLocators_Header.jpg);">
      <section class="mbfs-home-hero__header">
       <h2 class="mbfs-home-hero__header-subtitle">
         {{ 'DealerLocators.Header' | translate }}
        </h2>
        
         <p class="subheader">
            {{ 'DealerLocators.SubHeader' | translate }}
         </p>
        
      </section>
    </section>
    <ul *ngIf="isFrench"> <!--Canada French Brochures-->
      <div class="staticflex">
         <div>
            <div class="column-text">
               <li><div class="hyperlinktext"><a href="https://freightliner.com/dealer-search/" target="_blank">
                  <!-- <img src="/static/assets/img/dtf-assets/images/redesign/Freightliner_logo_footer.png"  style="width:109px; height:22px;">  -->
                  {{ 'DealerLocators.Freightliner' | translate }}</a></div></li>
               <li><div class="hyperlinktext"><a href="https://www.westernstartrucks.com/dealers/" target="_blank">
                  <!-- <img src="/static/assets/img/dtf-assets/images/redesign/western_star_logo_footer_cropped_W.png"  style="width:52px; height:23px;"> -->
                  {{ 'DealerLocators.WesternStar' | translate }}</a></div></li>
             
            </div>            
         </div>

         <div>
            <div class="column-text">
              <li><div class="hyperlinktext"><a href="https://thomasbuiltbuses.com/bus-sales-and-support/find-a-dealer/" target="_blank">
               <!-- <img src="/static/assets/img/dtf-assets/images/redesign/thomas_logo_footer.png"  style="width:90px; height:30px;"> -->
               {{ 'DealerLocators.ThomasBuilt' | translate }}</a></div></li>
              <li><div class="hyperlinktext"><a href="https://www.selectrucks.com/centers/" target="_blank">
               <!-- <img src="/static/assets/img/dtf-assets/images/redesign/selectrucks_logo_footer.png"  style="width:114px; height:12px;"> -->
               {{ 'DealerLocators.SelecTrucks' | translate }}</a></div></li>
            </div>
         </div>
      </div>
     </ul> 
      
    
   <!--Canada English Brochures-->
   <ul *ngIf="!isFrench">
      <br>
      <br>
      <div class="staticflex">
         <div>
            <div class="column-text">
               <li><div class="hyperlinktext"><a href="https://freightliner.com/dealer-search/" target="_blank">
                  <!-- <img src="/static/assets/img/dtf-assets/images/redesign/Freightliner_logo_footer.png"  style="width:109px; height:22px;">  -->
                  {{ 'DealerLocators.Freightliner' | translate }}</a></div></li>
               <li><div class="hyperlinktext"><a href="https://www.westernstartrucks.com/dealers/" target="_blank">
                  <!-- <img src="/static/assets/img/dtf-assets/images/redesign/western_star_logo_footer_cropped_W.png"  style="width:52px; height:23px;"> -->
                  {{ 'DealerLocators.WesternStar' | translate }}</a></div></li>
             
            </div>            
         </div>

         <div>
            <div class="column-text">
              <li><div class="hyperlinktext"><a href="https://thomasbuiltbuses.com/bus-sales-and-support/find-a-dealer/" target="_blank">
               <!-- <img src="/static/assets/img/dtf-assets/images/redesign/thomas_logo_footer.png"  style="width:90px; height:30px;"> -->
               {{ 'DealerLocators.ThomasBuilt' | translate }}</a></div></li>
              <li><div class="hyperlinktext"><a href="https://www.selectrucks.com/centers/" target="_blank">
               <!-- <img src="/static/assets/img/dtf-assets/images/redesign/selectrucks_logo_footer.png"  style="width:114px; height:12px;"> -->
               {{ 'DealerLocators.SelecTrucks' | translate }}</a></div></li>
            </div>
         </div>
      </div>
   </ul> 
   <div class="section-title-bottom">{{  'DealerLocators.ClickBrands' | translate }}</div>  
   
 </div>
 